module.exports = __webpack_public_path__ + "media/images/top/bg_new-71ed18b40322dc0b8a29dc1820e2ed38.png";